import { Component, Input } from '@angular/core';

@Component({
    selector: 'progress-bar',
    template: `
        <div class="progress-bar-container">
            <div
                class="progress-bar-indicator"
                style.width.%="{{progress * 100}}"
            >

            </div>
            <div class="progress-content">
                <ng-content></ng-content>
            </div>
        </div>
    `
})
export class ProgressBarComponent {
    @Input() progress: number = 0;
}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/progress-bar/progress-bar.ts